var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("span", { staticClass: "urlLink" }, [
        _c(
          "a",
          {
            staticStyle: { color: "black" },
            attrs: { href: _vm.link, target: "_blank" }
          },
          [_vm._v(_vm._s(_vm.link))]
        )
      ]),
      _c("br"),
      _c("br"),
      _c("qrcode-vue", { attrs: { value: _vm.link, size: "300", level: "H" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }